
import { Component, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOptionStatus'
import currencyOptionMixin from '@/mixin/currencyOption'
import {
  // getWithdrawList,
  tableExport,
  getPaidList,
  // paymentOrderStatistics,
  setOneClickChange,
  setOneClickUnfreeze
} from '@/api/task/withdraw'
import {
  getAntWithdraw,
  getWithdrawStatistics,
  getWithdrawStatus,
  getChildDetail,
  changeCashStatus,
  oneClickPayfor,
  getPayWalletList
} from '@/api/order/cashOrder'
import { notifiedStatusList, timeTypeList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { dateToSeconds, pickerOptions, getCurrentDate } from '@/utils/dateTime'
import pagination from '@/components/Pagination/index.vue'
import { delObjEmptyKey } from '@/utils'
import orderDetail from './components/orderDetail.vue'
import setOrderStatus from './components/setOrderStatus.vue'
import paidList from './components/paidList.vue'
import reject from './components/reject.vue'
import approval from './components/approval.vue'
import ModifyOrderStatusBulk from './components/ModifyOrderStatusBulk.vue'
import batchOrderNotify from './components/batchOrderNotify.vue'
import batchModifyFreezeOrder from './components/batchModifyFreezeOrder.vue'
import { getAccountGroupList } from '@/api/product/accountGroup'
import kick from './components/kickOut.vue'
import { Form as ElForm } from 'element-ui'
import cashWithdrawList from './components/cashWithdrawList.vue'
import PicsUploader from '@/components/PicsUploader/index.vue'
import cashInfo from './components/cash-info.vue'
import cashReject from './components/cashReject.vue'
import cashApproval from './components/cash-approval.vue'
import detailManage from '@/components/AntDetail/detailManage.vue'
import transactionDetails from '@/components/AntDetail/transactionDetails.vue'
import friendsList from '@/components/AntDetail/friends-list.vue'
import editAccount from '@/views/product/accountManage.vue'
import { getAntGoogleAuth } from '@/api/universal'

@Component({
  name: 'withdrawIndex',
  components: {
    pagination,
    orderDetail,
    setOrderStatus,
    paidList,
    reject,
    approval,
    ModifyOrderStatusBulk,
    batchOrderNotify,
    batchModifyFreezeOrder,
    kick,
    cashWithdrawList,
    PicsUploader,
    cashInfo,
    cashReject,
    cashApproval,
    detailManage,
    transactionDetails,
    friendsList,
    editAccount
  }
})
export default class extends Vue {
  queryForm: any = {
    order_number: null,
    child_ordernumber: null,
    start_time: null,
    end_time: null,
    status: null,
    reverse_order: null,
    handle_time_unit: timeTypeList[0],
    min_amount: null,
    max_amount: null,
    success_start_time: null,
    success_end_time: null,
    multi_order_number: null
  }
  get language() {
    return AppModule.language
  }

  setForm: any = {
    status: null,
    remarks: null,
    google_code: null
  }
  private rules: any = {
    status: [
      { required: true, message: 'Please enter status', trigger: 'blur' }
    ],
    remarks: [
      { required: true, message: 'Please enter remarks', trigger: 'blur' }
    ],
    attach: [
      { required: true, message: 'Please enter attach', trigger: 'blur' }
    ]
  }
  private dateType: string = 'Created Time'
  private sourceList: any[] = []
  private batchOrder: any[] = []
  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private timeTypeList = timeTypeList
  private date: any[] = getCurrentDate()
  private successDate: any[] = []
  private handleDate: any[] = []
  private pickerOptions = pickerOptions
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private loading: boolean = false
  private totalData: any = {
    volume: {},
    transactions: {}
  }
  private payWallet: any = []
  private checkPlatformAll: boolean = false
  private isIndeterminatePlatform: boolean = false
  private accountList: any = []
  private platformCheckAllChange(val: any) {
    // this.payWallets = []
    // this.accountList.forEach(item => {
    //   this.payWallets.push(item)
    // })
    this.payWallet = val ? this.accountList : []
    this.isIndeterminatePlatform = false
  }
  private handleCheckedPlatformChange(value: any) {
    let checkedCount = value.length
    this.checkPlatformAll = checkedCount === this.accountList.length
    this.isIndeterminatePlatform =
      checkedCount > 0 && checkedCount < this.accountList.length
  }

  private async onloadPayWalletList() {
    try {
      let data = {
        ...this.queryForm
      }
      await getPayWalletList(data).then((res: any) => {
        this.accountList = res
      })
    } catch (error) {}
  }

  private show: boolean = false
  // private total = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }

  private currentOrdernumber: number | null = null
  private currentOrder: any | null = null
  private action: string = ''
  private drawer: boolean = false
  private dialogVisible: boolean = false
  private dialogVisible1: boolean = false
  private dialogVisible2: boolean = false
  private dialogVisible3: boolean = false
  private dialogVisible4: boolean = false
  private dialogVisible5: boolean = false
  private expandedRows: any[] = []
  private ordernumbers: any[] = []
  private requiredErr: any = ''
  private requiredOrder: any = ''
  private requiredDate: any = ''
  private requiredRemarks: any = ''
  private requiredStatus: any = ''
  private multilength: any = ''
  private requiredRemarksGeogle: any = ''
  private requiredWallet: any = ''

  private changeOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multilength = str.split(',')
      this.multilength = this.multilength.filter((item: any) => {
        return item !== ''
      })
      this.payWallets = str.split(',').join(',')
    } else {
      this.multilength = ''
    }
  }

  private changeStatus(i) {
    if (i === 1) {
      this.show = true
    } else {
      this.show = false
    }
  }

  private geogleStatus: any = null
  private async onloadAntGoogleAuth() {
    try {
      await getAntGoogleAuth().then((res: any) => {
        this.geogleStatus = res.ant_google_switch
      })
    } catch (e) {}
  }

  // 归集设置
  private guijiVisible: boolean = false
  private openGuiJi() {
    this.guijiVisible = true
  }
  private closeGuiji() {
    this.guijiVisible = false
    this.hadleGetFilesListApi()
  }

  // 跳转地址
  private jumpAddress(row) {
    if (row.withdraw_info.coin_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/address/${row.withdraw_info.address}/transfers`
      )
    } else if (row.withdraw_info.coin_type === 'erc20') {
      window.open(`https://etherscan.io/address/${row.withdraw_info.address}`)
    }
  }
  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      delete this.queryForm.currency
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      delObjEmptyKey(data)
      this.orderList = []
      await getAntWithdraw(data).then((res: any) => {
        this.orderList = res.results
        this.orderList.forEach((item: any) => {
          this.$set(item, 'subOrderList', [])
          if (this.expandedRows.length > 0) {
            this.expandedRows.forEach(el => {
              if (el === item.id) {
                this.getPaidList(item)
              }
            })
          }
        })
        this.total = res.count
        this.listLoading = false
        // this.currentPage = this.currentPage
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private isDisabled(row, index) {
    return (row.status === 1 || row.status === 5) && row.notify_status !== 1
  }

  private selectList: any[] = []
  private handleSelectionChange(list) {
    this.selectList = list
  }
  private openDialog(orderInfo: any) {
    let { ordernumber, status, status_display } = orderInfo
    this.setForm = { ordernumber, status, status_display, status2: '' }
    // this.setForm.status = null
    this.dialogVisible = true
  }
  private dialogApproval: boolean = false
  private approval: any = {}
  private openDialogApproval(row: any) {
    // this.setForm.status = null
    this.approval = row
    this.dialogApproval = true
  }
  private async setSuccessStatus() {
    this.loading = true
    this.flag = true
    let {
      attach,
      remarks,
      status2: status,
      upstream_ordernumber
    } = this.setForm
    const data: any = {
      ordernumber: this.setForm.ordernumber,
      attach,
      remarks,
      status,
      upstream_ordernumber
    }

    try {
      await changeCashStatus(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message:
              'The task was created successfully, please contact another administrator for approval!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '任务创建成功，请联系其他管理员审批!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '任務創建成功，請聯系其他管理員審批!',
            type: 'success'
          })
        }
        this.loading = false
        this.flagStr()
        this.closeDialog()
      })
    } catch (e) {
      this.loading = false
      // this.closeDialog()
      this.flagStr()
    }
  }
  private info: any = {}
  private openDialog1(orderInfo: any) {
    this.info = orderInfo
    this.dialogVisible1 = true
  }

  // 批量发送订单回调
  private openDialog4() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 1 || this.selectList[i].status === 5) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible4 = true
  }

  // 批量修改冻结订单状态
  private openDialog3() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].status === 3) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.dialogVisible3 = true
  }
  // 踢出队列
  private opnekickOut: boolean = false
  private openKickOut() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].is_in_queue !== null) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.opnekickOut = true
  }

  // 创建时间监听
  @Watch('date', { immediate: true })
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
      this.queryForm.success_start_time = null
      this.queryForm.success_end_time = null
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private successTimeChange() {
    if (this.successDate) {
      this.queryForm.success_start_time = dateToSeconds(this.successDate[0])
      this.queryForm.success_end_time = dateToSeconds(this.successDate[1])
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    } else {
      this.queryForm.success_start_time = null
      this.queryForm.success_end_time = null
    }
  }

  // 一键解冻
  private opnekickUnfreezeShow: boolean = false
  private opnekickUnfreeze(id) {
    // this.queryForm.order_number = id
    this.opnekickUnfreezeShow = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.setForm.status = null
    this.setForm.remarks = null
    this.requiredErr = ''
    this.requiredOrder = ''
    this.requiredDate = ''
    this.requiredRemarks = ''
    this.requiredStatus = ''
    this.requiredRemarksGeogle = ''
    this.requiredWallet = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
    let arr: any = []
    this.selectList.forEach(item => {
      arr.push(item.ordernumber)
    })
    this.queryForm.multi_order_number = arr.toString()
  }

  // isShowDialogPayout
  private isShowDialogPayout: boolean = false
  private openDialog2() {
    this.isShowDialogPayout = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.setForm.status = null
    this.setForm.remarks = null
    this.requiredErr = ''
    this.requiredOrder = ''
    this.requiredDate = ''
    this.requiredRemarks = ''
    this.requiredRemarksGeogle = ''
    this.requiredStatus = ''
    this.requiredWallet = ''
    this.onloadPayWalletList()
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
    // console.log(this.selectList, 'ppp')
    let arr: any = []
    this.selectList.forEach(item => {
      arr.push(item.ordernumber)
    })
    this.queryForm.multi_order_number = arr.toString()
  }

  private closeDialogPayout() {
    this.isShowDialogPayout = false
    this.setForm.status = null
    this.setForm.remarks = null
    this.payWallet = []
    this.checkPlatformAll = false
    this.queryForm.multi_order_number = ''
  }

  private closeOpnekickUnfreeze() {
    this.opnekickUnfreezeShow = false
    this.setForm.status = null
    this.setForm.remarks = null
  }
  private async saveClickUnfreeze() {
    ;(this.$refs.queryForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        if (
          this.queryForm.status &&
          (!this.setForm.remarks || !this.setForm.status)
        ) {
          this.requiredRemarks = 'Remarks is required'
          this.requiredStatus = 'Status is required'
        } else {
          this.loading = true
          this.flag = true
          const params: any = {
            ...this.queryForm
          }
          const data: any = {
            ...this.setForm
          }
          delObjEmptyKey(params)
          await getWithdrawStatus(params, data)
            .then(() => {
              this.$message({
                message: 'Operation successfully!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.closeOpnekickUnfreeze()
              this.select()
            })
            .catch(() => {
              this.loading = false
              this.flagStr()
            })
        }
      } else {
        return false
      }
    })
  }

  private payWallets: any = ''
  private async saveDialogPayout() {
    ;(this.$refs.queryForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        if (
          this.queryForm.multi_order_number &&
          this.queryForm.multi_order_number.substr(-1) === ','
        ) {
          this.queryForm.multi_order_number =
            this.queryForm.multi_order_number.replace(/\S{1}$/, '')
        }
        if (!this.setForm.google_code) {
          this.requiredRemarksGeogle = 'Google Code is required'
        }
        if (this.payWallet.length === 0) {
          this.requiredWallet = 'Wallet ID is required'
        } else {
          this.loading = true
          this.flag = true
          let arr: any = []
          this.payWallet.forEach(item => {
            arr.push(item.id)
          })
          let filters: any = {
            ...this.queryForm
          }
          delObjEmptyKey(filters)
          const data: any = {
            filters: filters,
            pay_wallets: arr,
            google_code: this.setForm.google_code
          }
          await oneClickPayfor(data)
            .then(() => {
              this.$message({
                message: 'Operation successfully!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.select()
              this.closeDialogPayout()
            })
            .catch(() => {
              this.loading = false
              this.flagStr()
            })
        }
      } else {
        return false
      }
    })
  }

  private closeDialog() {
    this.dialogVisible = false
    this.dialogVisible1 = false
    this.currentOrder = null
    this.hadleGetFilesListApi()
  }

  private closeDialog1() {
    this.dialogVisible1 = false
    this.dialogVisible2 = false
    this.dialogVisible3 = false
    this.dialogVisible4 = false
    this.dialogVisible5 = false
    this.opnekickOut = false
    this.dialogApproval = false
    this.hadleGetFilesListApi()
  }

  private openDrawer(ordernumber: number) {
    this.currentOrdernumber = ordernumber
    this.action = ''
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    this.hadleGetFilesListApi()
  }

  // 蚂蚁详情
  private antDrawer: boolean = false
  private tabName: string = 'basicInformation'
  private closeAntDrawer(isManual: boolean = false) {
    if (isManual) {
      this.antDrawer = false
    }
    this.tabName = 'basicInformation'
  }
  private currentMerchant: any = {}
  private currentAccountId: any = ''
  private openEdit(merchant: any) {
    this.currentMerchant = merchant
    this.currentAccountId = merchant.ant_account
    this.antDrawer = true
  }

  private dateChange(e) {
    if (e === 'Success Time') {
      this.successDate = getCurrentDate()
      this.successTimeChange()
    } else {
      this.pickerChange()
    }
  }

  private select() {
    this.currentPage = 1
    this.paymentOrderStatistics()
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      order_number: null,
      child_ordernumber: null,
      start_time: null,
      end_time: null,
      status: null,
      reverse_order: null,
      source: null,
      handle_time_unit: timeTypeList[0],
      product_name: null,
      product_account_name: null,
      min_amount: null,
      max_amount: null,
      success_start_time: null,
      success_end_time: null
    }
    this.handleDate = []
    this.currentPage = 1
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.successDate = getCurrentDate()
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.paymentOrderStatistics()
    })
  }

  private async expandChange(row, expandedRows) {
    this.expandedRows = expandedRows.map(item => item.id)
    if (expandedRows.length > 0) {
      await this.getPaidList(row)
    }
  }

  private async getPaidList(row: any) {
    const data: any = {
      ordernumber: row.ordernumber
    }
    await getChildDetail(data).then((res: any) => {
      row.subOrderList = res
    })
  }

  // 出款统计
  private async paymentOrderStatistics() {
    try {
      let params: any = {
        ...this.queryForm
      }
      await getWithdrawStatistics(params).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await tableExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.sourceList = res.WITHDRAW_ORDER_SOUCE_CHOICES
      this.statusList = res.OUT_ORDER_STATUS_CHOICES
    })
    this.paymentOrderStatistics()
    this.hadleGetFilesListApi()
    this.onloadAntGoogleAuth()
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.init()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.cashOrder`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
